import script from "./ContactUs.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactUs.vue?vue&type=script&setup=true&lang=ts"

import "./ContactUs.vue?vue&type=style&index=0&id=b858f05e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b858f05e"]])

export default __exports__